import React, { useEffect } from 'react'
import './EkPlanning.css';
import Header from "../../components/Header/header";
import { Col, Row, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Footer from "../../components/Footer/Footer";
import EkPlanningWes from './EkPlanningWes/EkPlanningWes';
import EKPlanningTable from './EkPlanningTable/EKPlanningTable';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const EkPlanning = () => {

    const navigate = useNavigate();
    const { customerID, year, div, shipTo, city, customerName, vtr} = useParams();

    useEffect(() => {
    // If user came directly without selecting planning
    if (
      !customerID
    ) {
      toast.error(
        "You can't go directly to EK Planning Tab. Please select a customer first."
      );

      navigate("/customer-summary", { replace: true });
    }
  }, []);

    return (
        <div className="ekplanning_main_container">
            <div className="ekplanning_main">
                <div className="main_ekplanning">
                    <div className="ekplanning_header_main">
                        <Header />
                        <div className="ek-planning_header">
                            <Row className='ek-planning-header-data'>
                                <Col lg={2} className="ekPlanning_Col">
                                    <div className="user_id_main_planning_text">
                                        <Form.Label
                                            htmlFor="username"
                                            className="user_id_text_planning"
                                        >
                                            Jahr
                                        </Form.Label>
                                    </div>
                                    <div className="dropDown_jahr_planning">
                                        <Form.Select aria-label="Default select example" className='ekPlanning_input'>
                                            <option className='ekPlaning_option'>Select Jahr</option>
                                        </Form.Select>
                                    </div>
                                </Col>
                                <Col lg={2} className="ekPlanning_Col">
                                    <div className="user_id_main_planning_text">
                                        <Form.Label
                                            htmlFor="username"
                                            className="user_id_text_planning"
                                        >
                                            Div
                                        </Form.Label>
                                    </div>
                                    <div className="dropDown_jahr_planning">
                                        <Form.Select aria-label="Default select example" className='ekPlanning_input'>
                                            <option className='ekPlaning_option'>Select Div</option>
                                        </Form.Select>
                                    </div>
                                </Col>
                                <Col lg={2} className="ekPlanning_Col">
                                    {/* <div> */}
                                    <Form.Label htmlFor="username" className="ekPlanning_lable">
                                        Jahr-EK
                                    </Form.Label>
                                    {/* </div> */}
                                    {/* <div className=""> */}
                                    <Form.Control
                                        type="text"
                                        className='ekPlanning_input'
                                        id="username"
                                        placeholder="Enter Value"
                                        // value={username}
                                        // onChange={(e) => setUsername(e.target.value)}
                                        autoComplete="off"
                                    />
                                    {/* </div> */}
                                </Col>
                                <Col lg={2} className="ekPlanning_Col">
                                    <Form.Label htmlFor="username" className="ekPlanning_lable">
                                        Durchschnitts-EK
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="username"
                                        className='ekPlanning_input'
                                        placeholder="Enter Value"
                                        // value={username}
                                        // onChange={(e) => setUsername(e.target.value)}
                                        autoComplete="off"
                                        style={{ background: "rgb(236, 245, 166)" }}
                                    />
                                </Col>
                                <Col lg={2} className="ekPlanning_Col">
                                    {/* <div> */}
                                    <Form.Label htmlFor="username" className="ekPlanning_lable">
                                        Vorgabe
                                    </Form.Label>
                                    {/* </div> */}
                                    {/* <div className="ModifyUser_input"> */}
                                    <Form.Control
                                        type="text"
                                        id="username"
                                        className='ekPlanning_input'
                                        placeholder="Enter Text"
                                        // value={username}
                                        // onChange={(e) => setUsername(e.target.value)}
                                        autoComplete="off"
                                        style={{ background: "rgb(236, 245, 166)" }}
                                    />
                                    {/* </div> */}
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="Ekplanning_container">

                    </div>
                    {/* Ek Plannng Data */}
                    <div className='ekPlanning_Container'>
                        <EkPlanningWes />
                    </div>
                    {/* Ek Planning Table  */}
                    <div className='ekPlanning_Container'>
                        <EKPlanningTable />
                    </div>
                </div>
            </div>
            <div>
                <Footer className="footer" />
            </div>
        </div >
    )
}

export default EkPlanning